export default "__VITE_PUBLIC_ASSET__993e3e84__"